import store from "@/store"
import _ from "lodash"

export default {
  created() {
    this.debouncedResizeHandler = _.debounce(
      () => {
        let tableHeight = document.body.clientHeight - 160
        store.commit("backend/SET_TABLE_HEIGHT", tableHeight)
      },
      100,
      {
        leading: true,
        trailing: true
      }
    )
  },
  beforeMount() {
    window.addEventListener("resize", this.debouncedResizeHandler)
  },
  mounted() {
    this.debouncedResizeHandler()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.debouncedResizeHandler)
  }
}
